import Swiper from '../fpa/swiper/swiper-bundle.js';

function init() {
    const slider = document.querySelector('.js_keyFeatures__features');

    if (slider) {
        new Swiper(slider, {
            spaceBetween: 19,
            slidesPerView: 'auto',
            watchOverflow: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    freeMode: true,
                },
                400: {
                    freeMode: false,
                },
            },
        });
    }
}

$(document).ready(init);
